export const idUserSelector = (state) => state.auth.idUser;
export const emailSelector = (state) => state.auth.idEmail;
export const userPrivSelector = (state) => state.auth.userPriv;
export const instanceIdSelector = (state) => state.auth.instanceId;
